module.exports = __webpack_public_path__ + "static/media/piqipi.0e04d149.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/piqipi.png
// module id = 431
// module chunks = 0